import { AllowedHostsValidator, type AccessTokenProvider } from "@microsoft/kiota-abstractions";

// implement kiota authentication provider that always returns a static access token
export class StaticAccessTokenProvider implements AccessTokenProvider {
    private accessToken: string;
    private allowedHostsValidator: AllowedHostsValidator;

    constructor(accessToken: string, allowedHost: string) {
        this.accessToken = accessToken;
        this.allowedHostsValidator = new AllowedHostsValidator();
        this.allowedHostsValidator.setAllowedHosts(
            new Set<string>([allowedHost])
        )
    }
    public async getAuthorizationToken(): Promise<string> {
        return this.accessToken;
    }

    public getAllowedHostsValidator(): AllowedHostsValidator {
        return this.allowedHostsValidator;
    }
}
